// pages/HomePage/HomePage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import classes from './HomePage.module.css';

const HomePage = () => {
    return (
        <div className={classes.homePage}>
            <div className={classes.backgroundPattern}></div>

            <header className={classes.header}>
                <div className={classes.headerContent}>
                    <h1 className={classes.logo}>Cent Capital</h1>
                    <div className={classes.headerRight}>
                        <span className={classes.tagline}>Make sense of your cents</span>
                        <div className={classes.headerButtons}>
                            <Link to="/register" className={classes.signUpBtn}>
                                Sign Up Now
                            </Link>
                            <Link to="/login" className={classes.loginBtn}>
                                Login
                            </Link>
                        </div>
                    </div>
                </div>
            </header>

            <main className={classes.mainContent}>
                <div className={classes.heroSection}>
                    <div className={classes.heroText}>
                        <h2 className={classes.heroTitle}>
                            Take Control of Your
                            <span className={classes.titleAccent}> Financial Future</span>
                        </h2>
                        <p className={classes.heroSubtitle}>
                            Connect all your accounts in one secure place. Get instant insights, track your spending,
                            and build wealth with AI-powered financial guidance.
                        </p>
                        <div className={classes.heroButtons}>
                            <Link to="/register" className={classes.primaryBtn}>
                                Start Your Journey
                            </Link>
                            <Link to="/login" className={classes.secondaryBtn}>
                                I'm Already a Member
                            </Link>
                        </div>
                    </div>

                    <div className={classes.heroVisual}>
                        <div className={classes.mockupContainer}>
                            <div className={classes.mockup}>
                                <div className={classes.mockupHeader}>
                                    <div className={classes.mockupDots}>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </div>
                                <div className={classes.mockupContent}>
                                    <div className={classes.mockupCard}>
                                        <div className={classes.cardHeader}>Net Worth</div>
                                        <div className={classes.cardValue}>$127,350</div>
                                        <div className={classes.cardTrend}>+12.5% this month</div>
                                    </div>
                                    <div className={classes.mockupCard}>
                                        <div className={classes.cardHeader}>Monthly Savings</div>
                                        <div className={classes.cardValue}>$2,840</div>
                                        <div className={classes.cardTrend}>+8.3% vs last month</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <section className={classes.featuresSection}>
                    <div className={classes.featuresGrid}>
                        <div className={classes.feature}>
                            <div className={classes.featureIcon}>🔐</div>
                            <h3 className={classes.featureTitle}>Bank-Level Security</h3>
                            <p className={classes.featureText}>
                                Your data is protected with 256-bit encryption and read-only access to your accounts.
                            </p>
                        </div>

                        <div className={classes.feature}>
                            <div className={classes.featureIcon}>📊</div>
                            <h3 className={classes.featureTitle}>Real-Time Insights</h3>
                            <p className={classes.featureText}>
                                Get instant updates on your spending, savings, and investment performance across all accounts.
                            </p>
                        </div>

                        <div className={classes.feature}>
                            <div className={classes.featureIcon}>🎯</div>
                            <h3 className={classes.featureTitle}>Smart Goal Tracking</h3>
                            <p className={classes.featureText}>
                                Set and achieve financial goals with AI-powered recommendations and progress tracking.
                            </p>
                        </div>

                        <div className={classes.feature}>
                            <div className={classes.featureIcon}>💡</div>
                            <h3 className={classes.featureTitle}>Personalized Advice</h3>
                            <p className={classes.featureText}>
                                Receive tailored financial advice based on your spending patterns and financial goals.
                            </p>
                        </div>
                    </div>
                </section>

                <section className={classes.statsSection}>
                    <div className={classes.statsGrid}>
                        <div className={classes.stat}>
                            <div className={classes.statNumber}>500K+</div>
                            <div className={classes.statLabel}>Users Trust Us</div>
                        </div>
                        <div className={classes.stat}>
                            <div className={classes.statNumber}>$50B+</div>
                            <div className={classes.statLabel}>Assets Connected</div>
                        </div>
                        <div className={classes.stat}>
                            <div className={classes.statNumber}>99.9%</div>
                            <div className={classes.statLabel}>Uptime</div>
                        </div>
                        <div className={classes.stat}>
                            <div className={classes.statNumber}>4.9★</div>
                            <div className={classes.statLabel}>App Store Rating</div>
                        </div>
                    </div>
                </section>

                <section className={classes.ctaSection}>
                    <div className={classes.ctaContent}>
                        <h2 className={classes.ctaTitle}>Ready to Transform Your Financial Life?</h2>
                        <p className={classes.ctaSubtitle}>
                            Join thousands of users who have already taken control of their finances with Cent Capital.
                        </p>
                        <Link to="/register" className={classes.ctaButton}>
                            Get Started Free
                        </Link>
                    </div>
                </section>
            </main>

            <footer className={classes.footer}>
                <div className={classes.footerContent}>
                    <div className={classes.footerBrand}>
                        <h3 className={classes.footerLogo}>Cent Capital</h3>
                        <p className={classes.footerTagline}>Make sense of your cents</p>
                    </div>
                    <div className={classes.footerLinks}>
                        <a href="#" className={classes.footerLink}>Privacy Policy</a>
                        <a href="#" className={classes.footerLink}>Terms of Service</a>
                        <a href="#" className={classes.footerLink}>Contact Us</a>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default HomePage;